(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["electrolyte-comparison-table"] && !Shopify.designMode) return;
  try {
    
  /**
   * Mobile only: sizes/positions the progress-bar thumb under the table to
   * reflect its horizontal scroll position. `scroll` events don't bubble,
   * so listening on `document` in the capture phase is what lets one
   * delegated listener catch scrolling on any `.comparison-table__grid`.
   */
  function updateComparisonTableProgress(track) {
    const wrapper = track.closest('.comparison-table__inner');
    const bar = wrapper?.querySelector('.comparison-table__progress-bar');
    const trackEl = wrapper?.querySelector('.comparison-table__progress');
    if (!bar || !trackEl) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const thumbRatio = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
    const trackWidth = trackEl.clientWidth;
    const thumbWidth = Math.max(24, thumbRatio * trackWidth);
    const maxThumbOffset = Math.max(0, trackWidth - thumbWidth);
    const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;

    trackEl.style.display = maxScroll > 0 ? '' : 'none';
    bar.style.width = `${thumbWidth}px`;
    bar.style.transform = `translateX(${progress * maxThumbOffset}px)`;
  }

  document.addEventListener(
    'scroll',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('comparison-table__grid')) return;
      updateComparisonTableProgress(event.target);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('.comparison-table__grid').forEach(updateComparisonTableProgress);
  });

  document.querySelectorAll('.comparison-table__grid').forEach(updateComparisonTableProgress);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavor-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.flavor-tabs__tab');
    if (!tab) return;

    const nav = tab.closest('.flavor-tabs__nav');
    const wrapper = tab.closest('.flavor-tabs');
    if (!nav || !wrapper) return;

    nav.querySelectorAll('.flavor-tabs__tab').forEach((el) => {
      el.classList.remove('is-active');
      el.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');

    wrapper.querySelectorAll('.flavor-tabs__panel').forEach((el) => el.classList.remove('is-active'));
    const panel = wrapper.querySelector('#' + tab.dataset.tabTarget);
    if (panel) panel.classList.add('is-active');
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!button) return;

    const track = button
      .closest('.flavor-tabs__carousel-wrap')
      ?.querySelector('[data-carousel-track]');
    if (!track) return;

    const card = track.querySelector('.flavor-tabs__product');
    const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    const direction = button.hasAttribute('data-carousel-next') ? 1 : -1;

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  });

  /**
   * Finds the product card nearest the horizontal center of the track,
   * returning its index among the real (non-cloned) cards — cloned indices
   * wrap via modulo so the dots/loop logic never need to know about clones.
   */
  function getCenteredCardIndex(track) {
    const cards = track.querySelectorAll('.flavor-tabs__product');
    const realCount = Number(track.dataset.realCardCount) || cards.length;
    if (!cards.length) return { index: 0, realIndex: 0 };

    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;
    cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(cardCenter - trackCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return { index: closestIndex, realIndex: closestIndex % realCount };
  }

  /**
   * Mobile only: highlights the pagination dot nearest the product card
   * currently centered in the scroll-snap carousel. `scroll` events don't
   * bubble, so listening on `document` in the capture phase is what lets
   * one delegated listener catch scrolling on any `.flavor-tabs__products`.
   */
  function updateFlavorTabsDots(track) {
    const panel = track.closest('.flavor-tabs__panel');
    const dots = panel?.querySelectorAll('.flavor-tabs__dot');
    if (!dots?.length) return;

    const { realIndex } = getCenteredCardIndex(track);
    dots.forEach((dot, index) => dot.classList.toggle('is-active', index === realIndex));
  }

  /**
   * Infinite loop: clone the full set of cards before and after the real
   * set, so every real card — including the first and last — always has a
   * sibling to peek at on both sides (required for scroll-snap-align: center
   * to actually center it). Starts scrolled to the first real card, then
   * silently (no smooth-scroll) jumps by one set's width whenever the user
   * scrolls into a cloned region, landing on the equivalent real card so the
   * loop feels endless.
   */
  // Mobile only: this is the "center the first card" scroll-snap fix — the
  // desktop carousel's cards aren't center-snapped (see
  // .flavor-tabs__product's scroll-snap-align: start under .is-carousel), so
  // cloning them here for looping would only add unused DOM and risk
  // desktop-only layout bugs.
  const flavorTabsMobileQuery = window.matchMedia('(max-width: 749px)');

  function setupInfiniteCarousel(track) {
    if (!flavorTabsMobileQuery.matches) return;

    const realCards = Array.from(track.querySelectorAll('.flavor-tabs__product'));
    if (track.dataset.realCardCount || realCards.length < 2) return;

    const cloneSet = () =>
      realCards.map((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        return clone;
      });

    cloneSet()
      .reverse()
      .forEach((clone) => track.insertBefore(clone, track.firstChild));
    cloneSet().forEach((clone) => track.appendChild(clone));

    track.dataset.realCardCount = String(realCards.length);

    const firstRealCard = track.querySelectorAll('.flavor-tabs__product')[realCards.length];
    if (firstRealCard) {
      track.scrollLeft = firstRealCard.offsetLeft - (track.clientWidth - firstRealCard.offsetWidth) / 2;
    }
  }

  function loopFlavorTabsTrack(track) {
    const realCount = Number(track.dataset.realCardCount);
    if (!realCount) return;

    const cards = track.querySelectorAll('.flavor-tabs__product');
    const { index } = getCenteredCardIndex(track);
    if (index >= realCount && index < realCount * 2) return;

    const setWidth = cards[realCount].offsetLeft - cards[0].offsetLeft;
    track.scrollLeft += index < realCount ? setWidth : -setWidth;
  }

  document.querySelectorAll('[data-carousel-track]').forEach(setupInfiniteCarousel);

  document.addEventListener(
    'scroll',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('flavor-tabs__products')) return;
      updateFlavorTabsDots(event.target);
    },
    true
  );

  document.addEventListener(
    'scrollend',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.hasAttribute('data-carousel-track')) return;
      loopFlavorTabsTrack(event.target);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('.flavor-tabs__products').forEach(updateFlavorTabsDots);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydrate-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * Pins the section in place once it reaches the vertical center of the
   * viewport (via `position: sticky` on the section itself, inside a
   * taller spacer) and scrubs the stick-pack rotate/scale/shadow to scroll.
   * LIV-272: the animation starts while the section is still scrolling in
   * (LEAD_IN of the viewport height before it pins), so the stick is already
   * moving when it arrives and the pinned hold is shorter. The section
   * releases once the animation reaches 100%. Reverses cleanly on scroll up.
   */
  class ScrollReveal extends HTMLElement {
    // Must match --hydrate-banner-stage-height / --hydrate-banner-pin-distance in CSS.
    static STAGE_HEIGHT = 640;
    static PIN_DISTANCE = 420;
    static LEAD_IN = 0.4;

    connectedCallback() {
      this.spacer = this.closest('.hydrate-banner-pin-spacer');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pinEnabled = window.matchMedia('(min-width: 750px)').matches;

      if (this.reducedMotion) {
        this.style.setProperty('--progress', '1');
        this.classList.add('is-visible');
        return;
      }

      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      };

      // Horizon's "squeeze" desktop layout (≥990px) scrolls `.page-wrapper`
      // instead of the document, so `window` never fires a `scroll` event
      // there. Listen on every candidate scroll source rather than trying
      // to track the breakpoint ourselves.
      this.scrollTargets = [window, document, document.querySelector('.page-wrapper')].filter(Boolean);
      for (const target of this.scrollTargets) {
        target.addEventListener('scroll', this.onScroll, { passive: true });
      }
      window.addEventListener('resize', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      for (const target of this.scrollTargets ?? []) {
        target.removeEventListener('scroll', this.onScroll);
      }
      window.removeEventListener('resize', this.onScroll);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    update() {
      this.pinEnabled = window.matchMedia('(min-width: 750px)').matches;

      let progress;
      if (this.pinEnabled && this.spacer) {
        const rect = this.spacer.getBoundingClientRect();
        const stageHeight = ScrollReveal.STAGE_HEIGHT;
        const pinDistance = ScrollReveal.PIN_DISTANCE;
        // Matches the CSS `top: calc(50vh - (stageHeight / 2))` sticky offset:
        // the point at which the section is centered in the viewport and starts pinning.
        const topOffset = window.innerHeight / 2 - stageHeight / 2;
        const stuckRange = Math.max(1, rect.height - stageHeight) || pinDistance;
        const leadIn = window.innerHeight * ScrollReveal.LEAD_IN;

        progress = (topOffset + leadIn - rect.top) / (leadIn + stuckRange);
      } else {
        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const start = viewportHeight;
        const end = viewportHeight * 0.15;
        progress = (start - rect.top) / (start - end);
      }

      progress = Math.min(1, Math.max(0, progress));

      this.style.setProperty('--progress', progress.toFixed(4));
      // Text + button reveal partway through the rotate/shrink animation
      // instead of waiting for it to fully finish. LIV-272: not before the
      // stick has mostly turned and shrunk, so it doesn't sit across the
      // headline while it fades in.
      this.classList.toggle('is-visible', progress >= 0.65);
    }
  }

  customElements.define('scroll-reveal', ScrollReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-system-showcase"] && !Shopify.designMode) return;
  try {
    
  /**
   * LIV-422: driver for the pinned scroll. The pinned stretch runs from 0
   * (the pin engages) to 1 (it releases); scrolling stays free.
   *
   * Desktop (>=990px): the stretch is split into N + 1 slots - slot 0 at 0
   * (image closed, no card), then card k of N (1-based) at k / N. The
   * nearest slot picks the one current card (none at slot 0), so card 1
   * appears once the pin has engaged and the image has started opening.
   * A switch only toggles .is-visible; the crossfade is a fixed-length CSS
   * transition, so it always plays in full however fast the page scrolls.
   * The dots mark the current card and scroll to its slot on click.
   *
   * Mobile (<990px): the product image and card carousel pin the same way,
   * and scrolling down the pinned stretch moves the carousel sideways one
   * card per slot (N equal slots). The carousel's own dots scroll the page
   * to their card's slot.
   *
   * Both: the position through the stretch is eased into --hydration-reveal
   * each frame, so the split/powder reveal glides between a mouse wheel's
   * discrete steps instead of jumping with them. On desktop the page scrolls
   * inside .page-wrapper (base.css), not the document, so scroll listens in
   * the capture phase.
   */
  const hydrationDesktopQuery = window.matchMedia('(min-width: 990px)');
  const hydrationReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Desktop: scrolling back up switches to the previous card this far (in
  // slots) past the halfway point, so resting on a switch can't flicker.
  const HYDRATION_HYSTERESIS = 0.1;
  // Easing time constant for the image reveal (ms).
  const HYDRATION_EASE_MS = 90;
  const hydrationStates = new WeakMap();
  let hydrationFrame = 0;
  let hydrationLastTime = 0;

  function getHydrationState(section) {
    let state = hydrationStates.get(section);
    if (!state) {
      state = { active: -1, mobileIndex: -1, reveal: null };
      hydrationStates.set(section, state);
    }
    return state;
  }

  function getHydrationScroller(element) {
    for (let node = element.parentElement; node && node !== document.body; node = node.parentElement) {
      const { overflowY } = getComputedStyle(node);
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
    }
    return document.scrollingElement;
  }

  function measureHydration(section) {
    const pin = section.querySelector('.hydration-showcase__pin');
    const steps = section.querySelector('.hydration-showcase__steps');
    const slides = section.querySelectorAll('.hydration-showcase__slide');
    if (!pin || !steps || !slides.length || !steps.offsetHeight) return null;

    const scroller = getHydrationScroller(section);
    const viewportTop = scroller === document.scrollingElement ? 0 : scroller.getBoundingClientRect().top;
    const stepsRect = steps.getBoundingClientRect();
    // The pin engages when the step track's top reaches the pin's stuck
    // bottom edge, and releases when the track's bottom does.
    const pinBottom = viewportTop + (parseFloat(getComputedStyle(pin).top) || 0) + pin.offsetHeight;
    const offset = pinBottom - stepsRect.top;

    return {
      scroller,
      slides,
      dots: section.querySelectorAll('.hydration-showcase__dot'),
      count: slides.length,
      length: stepsRect.height,
      offset,
      progress: offset / stepsRect.height,
    };
  }

  // Desktop: nearest slot as a zero-based card index (-1 = slot 0, no card).
  function pickHydrationCard(state, position) {
    let active = Math.round(position) - 1;
    if (active < state.active && position >= state.active + 0.5 - HYDRATION_HYSTERESIS) active = state.active;
    return active;
  }

  // Mobile: card `index` owns the slot [index / N, (index + 1) / N).
  function getHydrationMobileIndex(progress, count) {
    return Math.min(Math.floor(progress * count), count - 1);
  }

  function updateHydration(now) {
    hydrationFrame = 0;
    const dt = hydrationLastTime ? Math.min(now - hydrationLastTime, 100) : 16;
    hydrationLastTime = now;
    const desktop = hydrationDesktopQuery.matches;
    let settling = false;

    document.querySelectorAll('.hydration-showcase').forEach((section) => {
      const state = getHydrationState(section);
      const inner = section.querySelector('.hydration-showcase__inner');
      const metrics = measureHydration(section);

      if (!metrics) {
        inner?.style.removeProperty('--hydration-reveal');
        section.querySelectorAll('.hydration-showcase__slide').forEach((slide) => slide.classList.remove('is-visible'));
        state.reveal = null;
        return;
      }

      const progress = Math.min(Math.max(metrics.progress, 0), 1);
      // Jump straight there when there's nothing to watch (well off screen,
      // first frame, reduced motion); otherwise ease toward it.
      const offscreen = metrics.offset < -window.innerHeight || metrics.offset > metrics.length + window.innerHeight;
      if (state.reveal === null || offscreen || hydrationReducedMotionQuery.matches) {
        state.reveal = progress;
      } else {
        state.reveal += (progress - state.reveal) * (1 - Math.exp(-dt / HYDRATION_EASE_MS));
        if (Math.abs(progress - state.reveal) < 0.0005) state.reveal = progress;
        else settling = true;
      }
      inner.style.setProperty('--hydration-reveal', state.reveal.toFixed(4));

      if (!desktop) {
        section.querySelectorAll('.hydration-showcase__slide').forEach((slide) => slide.classList.remove('is-visible'));
        state.active = -1;
        const index = getHydrationMobileIndex(progress, metrics.count);
        if (index !== state.mobileIndex) {
          state.mobileIndex = index;
          section.querySelector('slideshow-component')?.select?.(index);
        }
        return;
      }
      state.mobileIndex = -1;

      state.active = pickHydrationCard(state, progress * metrics.count);
      metrics.slides.forEach((slide, index) => slide.classList.toggle('is-visible', index === state.active));
      metrics.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === state.active ? 'true' : 'false'));
    });

    if (settling) {
      hydrationFrame = requestAnimationFrame(updateHydration);
    } else {
      hydrationLastTime = 0;
    }
  }

  function queueHydration() {
    if (!hydrationFrame) hydrationFrame = requestAnimationFrame(updateHydration);
  }

  document.addEventListener('click', (event) => {
    // Desktop dots scroll to their card's slot (k / N); mobile carousel dots
    // to the middle of theirs, so the scroll position (which picks the card)
    // agrees with the dot.
    const dot = event.target.closest?.('.hydration-showcase__dot');
    const mobileDot = event.target.closest?.('.hydration-showcase__carousel .slideshow-controls__dots button');
    if (!dot && !(mobileDot && !hydrationDesktopQuery.matches)) return;
    const section = (dot || mobileDot).closest('.hydration-showcase');
    const metrics = measureHydration(section);
    if (!metrics) return;

    const slot = dot
      ? ([...metrics.dots].indexOf(dot) + 1) / metrics.count
      : ([...mobileDot.closest('.slideshow-controls__dots').querySelectorAll('button')].indexOf(mobileDot) + 0.5) / metrics.count;
    metrics.scroller.scrollBy({
      top: (slot - metrics.progress) * metrics.length,
      behavior: hydrationReducedMotionQuery.matches ? 'instant' : 'smooth',
    });
  });

  // Capture phase: on desktop the page scrolls inside .page-wrapper, and
  // `scroll` doesn't bubble.
  document.addEventListener('scroll', queueHydration, { capture: true, passive: true });
  window.addEventListener('resize', queueHydration);
  hydrationDesktopQuery.addEventListener('change', queueHydration);
  document.addEventListener('shopify:section:load', queueHydration);
  queueHydration();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!button) return;

    const track = button.closest('.pdp-recs__carousel-wrap')?.querySelector('[data-carousel-track]');
    if (!track) return;

    const card = track.querySelector('.pdp-recs__product');
    const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    const direction = button.hasAttribute('data-carousel-next') ? 1 : -1;

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  });

  /**
   * Mobile only: highlights the pagination dot nearest the product card
   * currently centered in the scroll-snap carousel. `scroll` events don't
   * bubble, so listening on `document` in the capture phase is what lets
   * one delegated listener catch scrolling on any `.pdp-recs__products`.
   */
  function updatePdpRecsDots(track) {
    const wrapper = track.closest('.pdp-recs__inner');
    const dots = wrapper?.querySelectorAll('.pdp-recs__dot');
    const cards = track.querySelectorAll('.pdp-recs__product');
    if (!dots?.length || !cards.length) return;

    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;
    cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(cardCenter - trackCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
  }

  document.addEventListener(
    'scroll',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('pdp-recs__products')) return;
      updatePdpRecsDots(event.target);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('.pdp-recs__products').forEach(updatePdpRecsDots);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-transport3-comparison"] && !Shopify.designMode) return;
  try {
    
  /**
   * Mobile only: sizes/positions the progress-bar thumb under the card
   * carousel to reflect its horizontal scroll position. `scroll` events
   * don't bubble, so listening on `document` in the capture phase is what
   * lets one delegated listener catch scrolling on any `.pdp-t3-compare__items`.
   */
  function updatePdpT3CompareProgress(track) {
    const wrapper = track.closest('.pdp-t3-compare__inner');
    const bar = wrapper?.querySelector('.pdp-t3-compare__progress-bar');
    const trackEl = wrapper?.querySelector('.pdp-t3-compare__progress');
    if (!bar || !trackEl) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const thumbRatio = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
    const trackWidth = trackEl.clientWidth;
    const thumbWidth = Math.max(24, thumbRatio * trackWidth);
    const maxThumbOffset = Math.max(0, trackWidth - thumbWidth);
    const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;

    trackEl.style.display = maxScroll > 0 ? '' : 'none';
    bar.style.width = `${thumbWidth}px`;
    bar.style.transform = `translateX(${progress * maxThumbOffset}px)`;
  }

  document.addEventListener(
    'scroll',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('pdp-t3-compare__items')) return;
      updatePdpT3CompareProgress(event.target);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('.pdp-t3-compare__items').forEach(updatePdpT3CompareProgress);
  });

  document.querySelectorAll('.pdp-t3-compare__items').forEach(updatePdpT3CompareProgress);

  /**
   * Click/tap anywhere on a card to reveal its description - the sole way
   * to reveal it at any breakpoint (no hover-to-reveal).
   */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const card = event.target.closest('.pdp-t3-compare__card');
    if (!card) return;

    const toggle = card.querySelector('.pdp-t3-compare__toggle');
    const expanded = card.classList.toggle('is-expanded');
    toggle?.setAttribute('aria-expanded', String(expanded));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transport3-accordion"] && !Shopify.designMode) return;
  try {
    
  function updateTransportMedia(item, section) {
    const media = section.querySelector('.transport-accordion__media-active');
    if (!media) return;

    const src = item.dataset.transportSrc || section.dataset.transportDefaultSrc;
    const srcset = item.dataset.transportSrcset || section.dataset.transportDefaultSrcset;
    if (!src) return;

    media.src = src;
    if (srcset) {
      media.srcset = srcset;
    } else {
      media.removeAttribute('srcset');
    }
    media.alt = item.dataset.transportAlt || '';
    media.hidden = false;

    const fallback = section.querySelector('.transport-accordion__media-fallback');
    if (fallback) fallback.hidden = true;
  }

  document.querySelectorAll('.transport-accordion').forEach((section) => {
    const activeItem = section.querySelector('[data-transport-item].is-active');
    if (activeItem) updateTransportMedia(activeItem, section);
  });

  function activateTransportItem(item, group, section) {
    group.querySelectorAll('[data-transport-item]').forEach((el) => {
      el.classList.remove('is-active');
      el.querySelector('.transport-accordion__trigger')?.setAttribute('aria-expanded', 'false');
    });
    item.classList.add('is-active');
    item.querySelector('.transport-accordion__trigger')?.setAttribute('aria-expanded', 'true');

    updateTransportMedia(item, section);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.transport-accordion__trigger');
    if (!trigger) return;

    const item = trigger.closest('[data-transport-item]');
    const group = trigger.closest('.transport-accordion__items');
    const section = trigger.closest('.transport-accordion');
    if (!item || !group || !section) return;

    activateTransportItem(item, group, section);
  });

  // Desktop: pin the titles/image in place and scroll through the items
  // instead of clicking. The section is stretched to extra scroll runway
  // per item (--transport-item-count), and .transport-accordion__inner
  // holds itself in place via native CSS position: sticky (see stylesheet
  // below) while scrolling through that runway.
  //
  // LIV-218: this used to reimplement the pin manually in JS (position:
  // fixed, then position: absolute + a scroll listener writing top/left/
  // width every frame) on the mistaken assumption that position: sticky
  // "doesn't engage" in this theme because the page scrolls a custom
  // .page-wrapper div instead of window/html/body. That assumption was
  // wrong — sticky works fine on a custom scroll container; it was never
  // actually re-tested after the original (unrelated) bug it was blamed
  // for. The manual JS approach caused two rounds of real, hard-to-track
  // shaking (a `top`-driven layout-thrashing pattern, and smooth-scroll
  // easing fighting the per-frame compensation) that native sticky simply
  // doesn't have, since the browser positions it during compositing with
  // no JS or layout involved at all. All of that manual positioning logic -
  // the fixed/absolute pin, the captured left/width/height metrics, the
  // per-frame top writes, and the smooth-scroll toggle - is gone; only the
  // "which item is active" calculation below still needs the scroll
  // listener.
  const transportScrollQuery = window.matchMedia('(min-width: 990px)');

  // Mobile: no pin/runway (items sit in normal document flow, one at a time
  // taller when active) - just activate whichever item's title line is
  // nearest a fixed trigger line as the user scrolls past it, so items open
  // and close on scroll instead of requiring a tap.
  const transportMobileTriggerRatio = 0.4;

  function updateTransportMobileActive(section, group, items) {
    const triggerY = window.innerHeight * transportMobileTriggerRatio;

    let closestItem = null;
    let closestDistance = Infinity;
    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      const distance = Math.abs(rect.top - triggerY);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });

    if (closestItem && !closestItem.classList.contains('is-active')) {
      activateTransportItem(closestItem, group, section);
    }
  }

  // Hysteresis margin (as a fraction of one item's progress slice) an
  // adjacent-item crossing must clear before the active item actually
  // switches. Without this, tiny scroll jitter right at a boundary (a few
  // px either way - completely normal for a trackpad/wheel, not just fast
  // flicks) flips the active item and its full-size image back and forth
  // repeatedly, which reads as the whole section "shaking".
  const transportIndexHysteresis = 0.12;

  function updateTransportScrollProgress(section, group, items) {
    if (!transportScrollQuery.matches) {
      updateTransportMobileActive(section, group, items);
      return;
    }

    const scrollableDistance = section.offsetHeight - window.innerHeight;
    if (scrollableDistance <= 0) return;

    const rect = section.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -rect.top / scrollableDistance));
    section.parentElement?.style.setProperty('--transport-glow-progress', String(progress));
    const exactIndex = progress * items.length;
    const rawIndex = Math.min(items.length - 1, Math.floor(exactIndex));

    const currentIndex = items.findIndex((el) => el.classList.contains('is-active'));
    let index = rawIndex;
    if (currentIndex !== -1 && Math.abs(rawIndex - currentIndex) === 1) {
      if (rawIndex > currentIndex && exactIndex < currentIndex + 1 + transportIndexHysteresis) {
        index = currentIndex;
      } else if (rawIndex < currentIndex && exactIndex > currentIndex - transportIndexHysteresis) {
        index = currentIndex;
      }
    }

    const item = items[index];
    if (item && !item.classList.contains('is-active')) {
      activateTransportItem(item, group, section);
    }
  }

  const transportSections = Array.from(document.querySelectorAll('.transport-accordion')).map((section) => ({
    section,
    group: section.querySelector('.transport-accordion__items'),
    items: Array.from(section.querySelectorAll('[data-transport-item]')),
  }));

  // LIV-218 (shaking): this used to defer the actual update into the rAF
  // callback below, which runs on the *next* frame — but the browser has
  // already scrolled and painted the current frame by the time a 'scroll'
  // event fires, so deferring meant the active-item calculation always
  // landed one frame behind the scroll that triggered it. Running it
  // synchronously here still lands before this frame's paint (scroll events
  // fire pre-paint); the rAF is only used to reset the ticking flag,
  // coalescing any further 'scroll' events that fire within the same frame
  // rather than deferring the first one.
  let transportScrollTicking = false;
  function handleTransportScroll() {
    if (transportScrollTicking) return;
    transportScrollTicking = true;
    requestAnimationFrame(() => {
      transportScrollTicking = false;
    });
    transportSections.forEach(({ section, group, items }) => {
      if (group && items.length) updateTransportScrollProgress(section, group, items);
    });
  }

  // LIV-158: `.page-wrapper` (see layout/theme.liquid) is only actually a
  // scroll container at desktop widths (>=990px, see assets/base.css) —
  // html/body are pinned with overflow: hidden there, so .page-wrapper
  // handles scrolling. Below that breakpoint neither of those rules apply,
  // so the real scroll events fire on the window/document instead. Listening
  // on `.page-wrapper` only (as before) meant this never ran on mobile —
  // the item that happened to be active on load just stayed active forever,
  // which read as "acts like a normal click-only accordion". Listening on
  // both costs nothing: whichever one isn't the real scroll container simply
  // never fires.
  const transportScrollContainer = document.querySelector('.page-wrapper');

  if (transportScrollContainer) {
    transportScrollContainer.addEventListener('scroll', handleTransportScroll, { passive: true });
  }
  window.addEventListener('scroll', handleTransportScroll, { passive: true });
  window.addEventListener('resize', handleTransportScroll);
  handleTransportScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-by-pros"] && !Shopify.designMode) return;
  try {
    
  /**
   * Mobile only: highlights the pagination dot nearest the card currently
   * centered in the scroll-snap carousel. `scroll` events don't bubble, so
   * listening on `document` in the capture phase is what lets one
   * delegated listener catch scrolling on any `.trusted-pros__cards`.
   */
  function updateTrustedProsDots(track) {
    const wrapper = track.closest('.trusted-pros__inner');
    const dots = wrapper?.querySelectorAll('.trusted-pros__dot');
    // Clones included: mid-swipe across a loop seam the centered card can be
    // a clone, and it should still show its caption and light its dot.
    const cards = track.querySelectorAll('.trusted-pros__card');
    const realCount = track.querySelectorAll('.trusted-pros__card:not([data-loop-clone])').length;
    if (!cards.length || !realCount) return;

    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;
    cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(cardCenter - trackCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    const activeDot = closestIndex % realCount;
    dots?.forEach((dot, index) => dot.classList.toggle('is-active', index === activeDot));
    // Mobile: only the centered card shows its caption/quote - matches the
    // Figma mobile layout where the text sits below the card, not overlaid,
    // and only for the card currently focused in the carousel.
    cards.forEach((card, index) => card.classList.toggle('is-focused', index === closestIndex));
  }

  /**
   * Carousel loop (LIV-413): loops infinitely instead of dead-ending, on the
   * desktop arrow carousel (5+ cards, >=990px) and the mobile swipe carousel
   * (any card count, <=749px). In between, the cards are a static grid.
   * A full copy of the cards sits on each side of the real set; once a
   * scroll settles outside the real set, the track jumps one set-width back
   * into it. Clones are identical and snap-aligned, so the jump is invisible.
   */
  const trustedProsDesktopQuery = window.matchMedia('(min-width: 990px)');
  const trustedProsMobileQuery = window.matchMedia('(max-width: 749px)');

  function trustedProsShouldLoop(track) {
    if (trustedProsMobileQuery.matches) return true;
    return trustedProsDesktopQuery.matches && track.hasAttribute('data-carousel-track');
  }

  function trustedProsSetWidth(track) {
    const first = track.querySelector('.trusted-pros__card:not([data-loop-clone])');
    const firstClone = track.querySelector('[data-loop-clone]');
    return first && firstClone ? first.offsetLeft - firstClone.offsetLeft : 0;
  }

  function jumpTrustedPros(track, left) {
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    track.style.scrollBehavior = '';
  }

  function setupTrustedProsLoop(track) {
    track.querySelectorAll('[data-loop-clone]').forEach((clone) => clone.remove());
    delete track.dataset.loop;

    const cards = [...track.querySelectorAll('.trusted-pros__card')];
    if (!trustedProsShouldLoop(track) || cards.length < 2) return;

    const cloneSet = () =>
      cards.map((card) => {
        const clone = /** @type {HTMLElement} */ (card.cloneNode(true));
        clone.dataset.loopClone = '';
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.classList.remove('is-expanded');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
        return clone;
      });

    track.prepend(...cloneSet());
    track.append(...cloneSet());
    track.dataset.loop = '';
    jumpTrustedPros(track, trustedProsSetWidth(track));
    updateTrustedProsDots(track);
  }

  function normalizeTrustedProsLoop(track) {
    if (!('loop' in track.dataset)) return;

    const setWidth = trustedProsSetWidth(track);
    if (!setWidth) return;

    // Half a pixel of slack absorbs sub-pixel snap positions.
    if (track.scrollLeft < setWidth - 0.5) {
      jumpTrustedPros(track, track.scrollLeft + setWidth);
    } else if (track.scrollLeft >= setWidth * 2 - 0.5) {
      jumpTrustedPros(track, track.scrollLeft - setWidth);
    }
  }

  function setupAllTrustedProsLoops() {
    document.querySelectorAll('.trusted-pros__cards').forEach(setupTrustedProsLoop);
  }

  const supportsScrollEnd = 'onscrollend' in window;
  /** @type {WeakMap<HTMLElement, number>} */
  const trustedProsScrollTimers = new WeakMap();

  document.addEventListener(
    'scroll',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('trusted-pros__cards')) return;
      const track = event.target;
      updateTrustedProsDots(track);

      if (!supportsScrollEnd) {
        clearTimeout(trustedProsScrollTimers.get(track));
        trustedProsScrollTimers.set(
          track,
          setTimeout(() => normalizeTrustedProsLoop(track), 150)
        );
      }
    },
    true
  );

  if (supportsScrollEnd) {
    document.addEventListener(
      'scrollend',
      (event) => {
        if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('trusted-pros__cards')) return;
        normalizeTrustedProsLoop(event.target);
      },
      true
    );
  }

  setupAllTrustedProsLoops();
  trustedProsDesktopQuery.addEventListener('change', setupAllTrustedProsLoops);
  trustedProsMobileQuery.addEventListener('change', setupAllTrustedProsLoops);
  document.addEventListener('shopify:section:load', setupAllTrustedProsLoops);

  document.querySelectorAll('.trusted-pros__cards').forEach(updateTrustedProsDots);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!button) return;

    const track = button
      .closest('.trusted-pros__carousel-wrap')
      ?.querySelector('[data-carousel-track]');
    if (!track) return;

    const card = track.querySelector('.trusted-pros__card');
    const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;

    // Mid-animation clicks can land on a clone set's edge; pull back into
    // the real set first so there's always a full set of room ahead.
    normalizeTrustedProsLoop(track);
    const direction = button.hasAttribute('data-carousel-next') ? 1 : -1;

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.trusted-pros__cards').forEach(updateTrustedProsDots);
  });

  /**
   * Click/tap anywhere on a card to expand its quote — the sole way to
   * reveal it at any breakpoint (no hover-to-reveal). The whole card is the
   * click target, not just the "+"/"-" toggle.
   */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const card = event.target.closest('.trusted-pros__card.has-quote');
    if (!card) return;

    const toggle = card.querySelector('.trusted-pros__toggle');
    const expanded = card.classList.toggle('is-expanded');
    toggle?.setAttribute('aria-expanded', String(expanded));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-comparison-cards"] && !Shopify.designMode) return;
  try {
    
  /**
   * Mobile only: sizes/positions the progress-bar thumb under the card
   * carousel to reflect its horizontal scroll position. `scroll` events
   * don't bubble, so listening on `document` in the capture phase is what
   * lets one delegated listener catch scrolling on any `.video-comparison__items`.
   */
  function updateVideoComparisonProgress(track) {
    const wrapper = track.closest('.video-comparison__inner');
    const bar = wrapper?.querySelector('.video-comparison__progress-bar');
    const trackEl = wrapper?.querySelector('.video-comparison__progress');
    if (!bar || !trackEl) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const thumbRatio = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
    const trackWidth = trackEl.clientWidth;
    const thumbWidth = Math.max(24, thumbRatio * trackWidth);
    const maxThumbOffset = Math.max(0, trackWidth - thumbWidth);
    const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;

    trackEl.style.display = maxScroll > 0 ? '' : 'none';
    bar.style.width = `${thumbWidth}px`;
    bar.style.transform = `translateX(${progress * maxThumbOffset}px)`;
  }

  document.addEventListener(
    'scroll',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.classList.contains('video-comparison__items')) return;
      updateVideoComparisonProgress(event.target);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('.video-comparison__items').forEach(updateVideoComparisonProgress);
  });

  document.querySelectorAll('.video-comparison__items').forEach(updateVideoComparisonProgress);

  /**
   * Videos only play while their card is hovered — muted/loop so autoplay
   * restrictions don't apply once .play() is called from the hover handler.
   */
  document.querySelectorAll('.video-comparison__media').forEach((media) => {
    const video = media.querySelector('.video-comparison__video');
    if (!video) return;

    media.addEventListener('mouseenter', () => {
      video.currentTime = 0;
      video.play();
    });

    media.addEventListener('mouseleave', () => {
      video.pause();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
